
/* eslint-disable import/no-extraneous-dependencies, import/prefer-default-export */
import { writable } from "svelte/store";

// const notify = {
//     title,
//     subtitle,
//     color: 'error' | 'success' | 'info',
//     sticky,
//     timeout,

// }

const { subscribe, set, update } = writable({
    profileMenu: false,
    breadcrumbs: [
        {
            key: "video",
            label: "Video"
        },
        {
            key: "list",
            label: "List"
        }
    ], notify: []
});

const hideNotification = () => update(s => {
    s.notify.shift()
    return s
})

const showNotification = ({ timeout = 4000, isSticky, ...notify }) => {
    if (isSticky !== true) {
        setTimeout(hideNotification, timeout)
    }

    update(s => {
        s.notify.push(notify);

        return s
    })
}


export default {
    subscribe,
    SetTitle: (title) => {
        update(s => {
            s.title = title;
            return s;
        })
    },
    SetBreadCrumbs: (bc) => {
        update(s => {
            s.breadcrumbs = bc;
            return s;
        })
    },
    ToggleProfileMenu: () => {
        update(s => {
            s.profileMenu = !s.profileMenu;
            return s
        })
    },
    HideProfileMenu: () => {
        update(s => {
            s.profileMenu = false;
            return s
        })
    },
    ShowNotification: (notify) => {
        showNotification({ ...notify, color: notify.color ?? 'success' })

    },
    ShowError: (notify) => {
        showNotification({ ...notify, color: 'error' })

    },
    HideNotification: hideNotification,
};
